import { render, staticRenderFns } from "./DepartmentEditPage.vue?vue&type=template&id=7c523af6&"
import script from "./DepartmentEditPage.vue?vue&type=script&lang=js&"
export * from "./DepartmentEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports